import { render, staticRenderFns } from "./ManagerSettings.vue?vue&type=template&id=2c334540&scoped=true"
import script from "./ManagerSettings.vue?vue&type=script&lang=ts"
export * from "./ManagerSettings.vue?vue&type=script&lang=ts"
import style0 from "./ManagerSettings.vue?vue&type=style&index=0&id=2c334540&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c334540",
  null
  
)

export default component.exports